import { generateResourceSelectors } from '../generators/resource.selectors';

import * as types from './kpi-row-scoreboard.types';

export const kpiRowScoreboardSelectors = {
  ...generateResourceSelectors<types.IKpiRowScoreboard>((state) => state.resource.kpiRowScoreboard),
};
